export default __webpack_public_path__ + "static/logo-black-1b33ac6a2fc43e13747857093f03bcc9.png";